<template>
  <div>
    <Form ref="editModel" :model="editModel"  :label-width="140" inline>
      <FormItem label="字典类别名称：">
       {{editModel.dicCategroyName}}
      </FormItem>
      <FormItem label="字典类别代码：">
         {{editModel.dicCategroyCode}}
      </FormItem>
      <h3 class="mb-4">
        字典项数据
      </h3>
      <div class="dictionaryItems-panel">
        <Table border :columns="columns1" :data="dictionaryItems"></Table>
      </div>
    </Form>
     <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="close">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["editModelTemp"],
  data: function () {
    return {
      editModel: {},
      DictionarySingleModel: {
        dictionaryID: "",
        dictionaryCode: "",
        dictionaryValue: "",
        dicCategroyCode: "",
        sortNum: "0",
      },
      dictionaryItems: [],
      columns1: [
        {
          title: "字典值",
          key: "dictionaryValue",
        },
        {
          title: "字典代码",
          key: "dictionaryCode",
        },
        {
          title: "排序",
          key: "sortNum",
        },
          {
          title: "描述",
          key: "extend01",
        },
      ],
   
    };
  },

  created: function () {
    this.editModel = this.editModelTemp;
    this.getDictionaryListByCategroyCode();
    this.DictionarySingleModel.dicCategroyCode = this.editModel.dicCategroyCode;
  },

  methods: {
    //获取字典项数据
    getDictionaryListByCategroyCode() {
      let categroyCode = this.editModel.dicCategroyCode;
      this.$api
        .get(
          `dictionary/getDictionaryListByCategroyCode?categroyCode=${categroyCode}`
        )
        .then((rsp) => {
          if (rsp != false) {
            this.dictionaryItems = rsp.data;
          }
        });
    },
  
    close() {
      this.$emit("close");
    },
  
  },
};
</script>
<style scoped>
.w-180 {
  width: 120px;
}
.dictionaryItems-panel {
  max-height: 300 !important;
  overflow: auto;
}
</style>